import css from '../tpl-css/style-section-grid-item-kynorelle-02.js';
const html = `
<style>${css}</style>
<div
  data-attribute="card-container"
  data-id="unique-id"
  data-background="#FFFFFF"
  data-top-padding="false"
  data-bottom-padding="true"
  data-color="#000000"
  style="background-color: #ffffff; color: #000000; --text-color: #000000;"
>
  <div data-attribute="container" class="">
    <div class="wrap-card">
      <div data-show="false" data-attribute="title-card" class="title-card" style="display: none;"></div>
      <div
        data-attribute="wrap-body-section"
        data-background="#003568"
        style="background-color: #003568; --background-color-body: #003568;"
        class="wrap-body-section"
      >
        <div data-attribute="block-markqueue" class="block-markqueue" data-markqueue-duplicated="true">
          <div data-attribute="item-markqueue" class="item-markqueue">
            <div class="icon-item">
              <img
                data-attribute="icon-item-markqueue"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9c4b7a23628bae9c6b0.png"
                alt=""
              />
            </div>
            <div data-attribute="text-item-markqueue" class="text-item">
              No squeeze. No adjust. Just moves with you.
            </div>
          </div>

          <div data-attribute="item-markqueue" class="item-markqueue">
            <div class="icon-item">
              <img
                data-attribute="icon-item-markqueue"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9c4b7a23628bae9c6b0.png"
                alt=""
              />
            </div>
            <div data-attribute="text-item-markqueue" class="text-item">
              No squeeze. No adjust. Just moves with you.
            </div>
          </div>

          <div data-attribute="item-markqueue" class="item-markqueue">
            <div class="icon-item">
              <img
                data-attribute="icon-item-markqueue"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9c4b7a23628bae9c6b0.png"
                alt=""
              />
            </div>
            <div data-attribute="text-item-markqueue" class="text-item">
              No squeeze. No adjust. Just moves with you.
            </div>
          </div>
        </div>
        <div
          data-col-perview="3"
          data-attribute="block-img-product"
          class="block-img-product"
          style="--col-perview: 3;"
        >
          <div data-attribute="item" class="item-img-product">
            <img
              data-attribute="image-item-img-product"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9b4fe7e9234a82e5994.png"
              alt=""
            />
          </div>

          <div data-attribute="item" class="item-img-product">
            <img
              data-attribute="image-item-img-product"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9b901bad3da27b5b09b.png"
              alt=""
            />
          </div>

          <div data-attribute="item" class="item-img-product">
            <img
              data-attribute="image-item-img-product"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9bd4a356731b3fd4025.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

`;
export default html;
